import { defineMessages } from 'react-intl';

export default defineMessages({
  someWentWrong: {
    id: 'src.pages.Error.error.someWentWrong',
    defaultMessage: 'Uh oh! Something went wrong. Please try again later or give us a call at ',
  },
  phoneNumber: {
    id: 'src.pages.Error.error.phoneNumber',
    defaultMessage: '1-844-766-6384.',
  },
  backToDashboard: {
    id: 'src.pages.Error.error.backToDashboard',
    defaultMessage: 'Back to dashboard',
  },
});
